import { Card, Box, TextField, Icon, Button } from "@nike/eds";
import { StoreDispatch } from "../../../shared/store/Store";
import { useDispatch } from "react-redux";
import { searchProductByCode } from "../../../shared/store/reducers/OverviewReducer";
import { useSearchParams } from "react-router-dom";
import { useEffect } from 'react';

export function SearchComponent() {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch: StoreDispatch = useDispatch();

    const onSearch = () => {
        const searchInput = document.getElementById('search-input') as HTMLInputElement;

        searchParams.set('q', searchInput.value);
        setSearchParams(searchParams);

        dispatch(searchProductByCode(searchInput.value));
    }

    useEffect(() => {
        const query = searchParams.get('q') || '';
        const searchInput = document.getElementById('search-input') as HTMLInputElement;

        if (searchInput) {
            searchInput.value = query;
        }

        if (query) {
            dispatch(searchProductByCode(query));
        }
    }, [dispatch, searchParams]);

    return (
        <Card className="eds-grid eds-grid--m-cols-8">
            <Box className="eds-grid--m-col-7">
                <TextField id="search-input" label="Search" hideLabel={true} placeholder="Search product code (e.g. 101900-100)" beforeSlot={<Icon name="Search" />}/>
            </Box>
            
            <Box className="eds-grid--m-col-1">
                <Button size="large" variant="primary" onClick={onSearch} beforeSlot={<Icon name="Search" />}>
                    Search
                </Button>
            </Box>
        </Card>
    )
}